import React, { Component } from 'react';

export class AiReview extends Component {
    render() {
        var w = window.innerWidth
        var h = window.innerHeight
        if (w > 640) {
            w = 640
        }
        if (h > 640) {
            h = 640
        }
        const note1 =<div className='ai-review-note'>
        Actual presentation might appear slightly different from preview.
        Aquamarine stones come in a variety of shades and in some instances
        appear clear in color. Your stone may not be as vibrant as the image
        depicted above.  The natural color gemstones featured here may have been
        subject to an enhancement process or treatment (e.g. heating, oiling,
        diffusion, waxing, etc.). This treatment may not be permanent and may
        require special care and should be cleaned by rinsing in warm water and
        drying with a soft cloth. Diamond carat weights (CT.) represent the
        approximate total weight (T.W.) of all diamonds in each setting.</div>
        //const note2a = <div><font color='red'>{SPECIAL_NOTE_BIG}</font></div>
        //const note2a = <div></div>
        var note2 = <div className='ai-review-note'>Order processing requires <font color='red'>10 Business days PLUS shipping time</font> based on the shipping method you choose. Signature required for items over $1,000.</div>
        if (this.props.site ==='Z')
            note2 = <div className='ai-review-note'>Order processing requires <font color='red'>10 Business days PLUS shipping time</font> based on the shipping method you choose. Signature required for items over $1,000.</div>
        let noteGem =''
        let tableDesc=[]
            
        for (let k in Object.keys(this.props.properties))
        {
            if (k !== '0') {
                tableDesc.push(<br key={k+'|br'}/>)
                tableDesc.push(<div key={k+'|section'} className='ai-review-section'><h2>{'Matching ' + this.props.properties[k].refresh_parent.product_type + ' Information'}</h2></div>)
                tableDesc.push(<div key={k+'|title'} className='ai-review-title'>{this.props.properties[k].refresh_parent.description}</div>)
            }
            //console.log(k, this.props.properties[k].refresh_parent)
           //console.log('REVIEW STATE',this.props.properties)
            for (let key in this.props.properties[k].refresh_parent.specs)
            {
              let p = this.props.properties[k].refresh_parent.specs[key]
              
              tableDesc.push (<div key={k+'|'+key} className='ai-table-group'>{p.group}</div>)
              let i='1'
              for (let key2 in p.properties){
                let p2 = p.properties[key2]
                tableDesc.push(<div key={k+'|'+key +'-'+key2} className='ai-table-row'><div className={'ai-table-column1 ai-table-background'+i}>{p2.name}</div><div className={'ai-table-column2 ai-table-background'+i}>{p2.description}</div></div>)
                if (i === '1') i = '2'
                else i = '1'
              }
              
              
            }
        }
                    
            //let headercolor ='ai-review-header ai-review-' + window.currentSite
 
        if (this.props.gems)
         noteGem = <div className='ai-review-note'>Most natural gemstones pictured have been subject to an enhancement process or treatment (e.g. heating, oiling, diffusion, waxing, etc.), which may not be permanent and may require special care. Please refer to the FAQ section below for more information about gemstone enhancements and special care recommendations.</div>
        return (
            <div className={"ai-review " /* + this.props.showReview */}>
                        <div className='ai-review-section'><h2>{this.props.type + ' Information'}</h2></div>
                        <div className='ai-review-title'> {this.props.description}</div> 
                        {tableDesc}
                        {/* <div className='ai-review-note'> */}
                        {noteGem}
                        {/* </div>    */}
                        {/* <div className='ai-review-note'></div> */}
                        {/* <div className='ai-review-note'> */}
                        {note1}
                        {/* </div>   */}     
                        {/* <div className='ai-review-note'>
                        {note2a}
                        </div>   */}     
                        {/* <div className='ai-review-note'> */}
                        {note2}
                        {/* </div>   */}     
                        <div className='ai-version'>Version {this.props.version}</div>
            </div>
        )
    }
}
export default AiReview;



// WEBPACK FOOTER //
// ./src/layout/AiReview.js